// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"745":"4603db7f","968":"d3ec5fa4"}[chunkId] + ".chunk.js";
};